import { render, staticRenderFns } from "./OrdersCollapseProducts.vue?vue&type=template&id=5f8a30b8&"
import script from "./OrdersCollapseProducts.vue?vue&type=script&lang=js&"
export * from "./OrdersCollapseProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports